import get from 'lodash-es/get';
import toArray from 'lodash-es/toArray';
import forEach from 'lodash-es/forEach';
import { API } from '@/api/config';

/***
 * Класс для работы с избранным
 */
class Favorite {
  /***
   * Массив товаров в избранном
   * @type {Object[]|null}
   */
  static favorite = null;

  /***
   * Ссылка на API
   * @type {string}
   */
  static baseUrl = !PROD ?
    `${API.DEVELOP_USER}/favorite` :
    SAND ?
      `${API.SAND_USER}/favorite` :
      `${API.PROD_USER}/favorite`;

  /***
   * Инициализация
   */
  static init = () => {
    const url = `${Favorite.baseUrl}/get`;

    fetch(url)
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error(res.statusText);
      })
      .then((res) => {
        Favorite.favorite = get(res, 'result.favorites', []);
        Favorite.updateCounter();
        window.Block.ProductControl?.updateControl();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  /***
   * Добавление товаров в избранное
   * @param offerId{String} - id товара
   * @return {Promise<String>} - id товара
   */
  static add = ({ offerId }) => {
    const url = `${Favorite.baseUrl}/add`;

    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({ offerId }),
    })
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error(res.statusText);
      })
      .then((res) => {
        Favorite.favorite = get(res, 'result.favorites', []);
        Favorite.updateCounter();
        return offerId;
      })
      .catch((err) => {
        console.error(err);
      });
  };

  /***
   * Удаление товаров из избранного
   * @param offerId{String} - id товара
   * @return {Promise<String>} - id товара
   */
  static remove = ({ offerId }) => {
    const url = `${Favorite.baseUrl}/remove`;

    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({ offerId }),
    })
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error(res.statusText);
      })
      .then((res) => {
        Favorite.favorite = get(res, 'result.favorites', null);
        Favorite.updateCounter();
        return offerId;
      })
      .catch((err) => {
        console.error(err);
      });
  };

  /***
   * Добавление/удаление товаров
   * @param toggle{Boolean} - добавить/удалить
   * @param offerId{String} - id товара
   * @return {Promise<String>} - id товара
   */
  static toggle = ({ toggle, offerId }) => {
    if (toggle) return window.Block.Favorite.add({ offerId });
    else return window.Block.Favorite.remove({ offerId });
  };

  static updateCounter = () => {
    const favoriteCounters = toArray(document.querySelectorAll('[data-counter-favorite]'));
    const count = get(Favorite, 'favorite.length', 0);
    forEach(favoriteCounters, (counter) => {
      const max = counter.dataset['max'] || Infinity;
      counter.innerHTML = count > max ? `${max}+` : count;
      counter.classList.toggle('d-none', !count > 0);
    });
  };

  /**
   * Установка данных избранного
   * @param favorite{Array} - массив избранного
   * @param update{Boolean} - нужно ли обновлять контролы
   */
  static setData = ({ favorite, update = true }) => {
    Favorite.favorite = favorite;
    Favorite.updateCounter();
    if (update) window.Block.ProductControl?.updateControl();
  };
}

if (NOT_PROD) Favorite.init();

window.Block.Favorite = Favorite;
